import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg_ansiedad})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Ansiedad</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Ansiedad</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
              <div className="col-12">
                  <h4>Introducción</h4>
                  <p className="text-muted">La ansiedad es una emoción natural y una parte normal de la experiencia humana. Es una respuesta del cuerpo al estrés, caracterizada por sentimientos de miedo, temor o inquietud. Sin embargo, cuando estos sentimientos son excesivos, persistentes y desproporcionados a la situación que los provoca, interfiriendo significativamente con la vida diaria, se habla de un trastorno de ansiedad.</p>
<br />
                  <h4 className='text-warning'>¿Qué es la ansiedad?</h4>
                  <p className="text-muted">La ansiedad puede manifestarse de diversas formas, afectando tanto el cuerpo como la mente. Es esa sensación de nerviosismo o preocupación que a veces sentimos antes de un examen importante, una entrevista de trabajo, o una situación desconocida. En su justa medida, puede incluso ser beneficiosa, ya que nos prepara para reaccionar ante el peligro.
                  Cuando la ansiedad se vuelve un trastorno, va más allá de un nerviosismo ocasional. Es una afección en la que la ansiedad no desaparece, puede empeorar con el tiempo y los síntomas pueden interferir seriamente con las actividades cotidianas, como el trabajo, la escuela y las relaciones personales.</p>
                  
                  
<br />               
                      <h4>Síntomas comunes</h4>
                      <p className="text-muted">Los síntomas de la ansiedad pueden variar de una persona a otra y entre los diferentes tipos de trastornos de ansiedad, pero generalmente incluyen una combinación de:</p>
                      <p className="text-muted para-desc">Síntomas físicos:</p>
                         <ul className="list-unstyled feature-list mb-0 text-muted">
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Palpitaciones o latidos cardíacos acelerados. </li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Sudoración. </li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Temblores o sacudidas. </li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Sensación de falta de aire o asfixia, entre otros. </li>                        
                      </ul>   
<br />
                       <p className="text-muted para-desc">Síntomas cognitivos:</p>
                         <ul className="list-unstyled feature-list mb-0 text-muted">
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Preocupación excesiva e incontrolable.</li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Pensamientos catastrofistas. </li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Dificultad para concentrarse o "mente en blanco". </li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Irritabilidad, entre otros. </li>                        
                      </ul>   
<br />
                       <p className="text-muted para-desc">Síntomas conductuales:</p>
                         <ul className="list-unstyled feature-list mb-0 text-muted">
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Evitación de situaciones, lugares o actividades que provocan ansiedad.</li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Inquietud o agitación. </li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Dificultad para relajarse. </li>
                          <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i> Cambios en los patrones de comportamiento. </li>                        
                      </ul>    
               
      <br />       

                  <h4>Tratamientos</h4>
                  <p className="text-muted">El tratamiento de la ansiedad es muy efectivo y generalmente implica una combinación de enfoques. Lo más beneficioso suele ser una combinación personalizada.</p>
                  <ul className="list-unstyled feature-list mb-0 text-muted">
                      <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i>Terapia Cognitivo-Conductual (TCC).</li>
                      <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i>Medicamentos.</li>
                      <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i>Cambios en el estilo de vida y Estrategias de Autocuidado. </li>
                      <li className="h6 fw-normal"><i className="mdi mdi-chevron-double-right me-2"></i>Neuromodulación.</li>                      
                  </ul>
              </div>
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
